/**
 * Puts `text` into a textarea as if it had been typed, replacing what was
 * there: React tracks a controlled field's value itself, so the value goes
 * through the native setter and an `input` event follows, which React turns
 * into the field's onChange. Then the field takes focus, caret at the end.
 */
export const typeIntoTextarea = (
  textarea: HTMLTextAreaElement,
  text: string
): void => {
  const setValue = Object.getOwnPropertyDescriptor(
    HTMLTextAreaElement.prototype,
    'value'
  )?.set;

  if (setValue) setValue.call(textarea, text);
  else textarea.value = text;

  textarea.dispatchEvent(new Event('input', { bubbles: true }));
  textarea.focus();
  textarea.setSelectionRange(text.length, text.length);
};
